import { conversationLanguages, } from 'lib-shared-languages';
/**
 * Converts a list of languages codes to language selector list value.
 *
 * @param codes The list of language codes.
 */
export function languageCodesToSelectionListValue(codes) {
    return codes
        .map((code) => conversationLanguages.find((conversationLanguage) => conversationLanguage.code === code))
        .filter(Boolean);
}
